"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMessagepublishexception = exports.MessagePublishException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("@amzn/coral-typescript-types-pieces");
const ihm_js_coral_client_1 = require("@amzn/ihm-js-coral-client");
class MessagePublishException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MessagePublishException#clone(obj: PlainObjectFrom<MessagePublishException>) method.
     */
    constructor(__message) {
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MessagePublishException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */
    static clone(obj) {
        return new MessagePublishException(obj.message);
    }
    static fromJson(data) {
        return new MessagePublishException((($$val) => $$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val) => $$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message),
        });
    }
}
exports.MessagePublishException = MessagePublishException;
MessagePublishException.fullyQualifiedTypeName = "com.amazon.coral.service.jms#MessagePublishException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MessagePublishException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MessagePublishException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
function validateMessagepublishexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMessagepublishexception = validateMessagepublishexception;
